import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () =>
        import('./pages/login/index.vue'),
      meta: {
        title: '注册登陆'
      }
    },
    {
      path: '/360login',
      name: '360login',
      component: () =>
        import('./pages/login/360Login.vue'),
      meta: {
        title: '注册登陆'
      }
    },
    {
      path: '/',
      component: () => import('./pages/serviceAppointment/home.vue'),
      name: 'home-service',
      meta: {
        title: '服务预约'
      }
    },
    {
      path: '/subscribeInside',
      component: () => import('./pages/serviceAppointment/subscribeInside.vue'),
      name: 'subscribe-inside',
      meta: {
        title: '预约内部员工'
      }
    },
    {
      path: '/myMakeAnAppointment',
      component: () => import('./pages/serviceAppointment/myMakeAnAppointment.vue'),
      name: 'my-make-an-appointment',
      meta: {
        title: '我的预约'
      }
    },
    {
      path: '/serviceMakeAnAppointment',
      component: () => import('./pages/serviceAppointment/serviceMakeAnAppointment.vue'),
      name: 'service-make-an-appointment',
      meta: {
        title: '服务预约',
        keepAlice: true
      }
    },
    {
      path: '/orderDetails',
      name: 'order-details',
      component: () => import('./pages/serviceAppointment/orderDetails.vue'),
      name: 'order-details',
      meta: {
        title: '预约详情',
        keepAlice: true
      }
    },
    {
      path: '/beAnAlternate',
      name: 'be-an-alternate',
      component: () => import('./pages/serviceAppointment/beAnAlternate.vue'),
      name: 'be-an-alternate',
      meta: {
        title: '服务预约',
        keepAlice: true
      }
    },
    {
      path: '/candidateInfo',
      name: 'candidate-info',
      component: () => import('./pages/serviceAppointment/candidateInfo.vue'),
      name: 'candidate-info',
      meta: {
        title: '候补预约信息',
        keepAlice: true
      }
    }
  ]
})
